import React from 'react';
import { Button, Modal } from '@avila-tek/ui/src';
import { Variant, Option, Product } from '../../../models';
import { useNotify } from '../../../hooks';
import { validateUpdateVariantForm } from '../../../lib/formValidations';
import VariantInfo from './VariantInfo';
import VariantOptions from './VariantOptions';

interface VariantModalProps {
  isOpen: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  addVariant: (variantItem: Partial<Variant>) => void;
  productOptions: Option[];
  product: Product;
}

export default function VariantModal({
  isOpen,
  setOpen,
  addVariant,
  productOptions,
  product,
}: VariantModalProps) {
  const notify = useNotify();
  const [formState, setFormState] = React.useState<Partial<Variant>>({
    sku: '',
    stock: 0,
    price: 0,
    compareAtPrice: 0,
    agreedPrice: 0,
    codesAutogenerated: true,
    electronicCodes: [],
    option: {
      option1: '',
      option2: '',
      option3: '',
    },
    isOnline: false,
  });

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const {
        sku,
        stock,
        price,
        compareAtPrice,
        agreedPrice,
        option,
        electronicCodes,
        codesAutogenerated,
        isOnline,
      } = formState;

      const { option1, option2, option3 } = option;

      const error = validateUpdateVariantForm({
        action: 'create',
        variant: {
          sku,
          stock,
          price,
          compareAtPrice,
          agreedPrice,
          option,
          electronicCodes,
          codesAutogenerated,
          isOnline,
        },
        product,
      });
      if (error) return notify(error, 'error');

      const record = {
        sku,
        stock: Number(stock),
        option: {
          option1,
          option2,
          option3,
        },
        electronicCodes,
        codesAutogenerated,
        isOnline,
        price: Number(price),
        compareAtPrice: Number(compareAtPrice),
        agreedPrice: Number(agreedPrice),
      };

      addVariant(record);
    } catch (err) {
      console.log(err);
      notify(`${err.message}`, 'error');
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      setOpen={setOpen}
      className="md:max-w-[80%] md:ml-72"
    >
      <form method="POST" onSubmit={onSubmit}>
        <div className="bg-white rounded-lg">
          <Modal.Title title="Crear variante" setIsOpen={setOpen} />
          <div>
            {/* Variants info */}
            <VariantInfo setFormVariant={setFormState} />
            {/* Variants options */}
            <VariantOptions
              formState={formState}
              setFormState={setFormState}
              options={productOptions}
            />
            <div className="flex w-full items-center justify-end px-6 py-3 ">
              <Button type="submit" className="w-fit">
                Crear
              </Button>
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
}
